import { HeaderContext } from '@tanstack/table-core';
import { capitalize } from 'lodash';
import { TransactionPlan } from 'types/domain';

type TransactionPlanTableKey = 'contact_name' | keyof TransactionPlan;

const curriedTransformTableKeyToReadable = (header: HeaderContext<TransactionPlan, unknown>) =>
    transformTableKeyToReadable(header.column.id as TransactionPlanTableKey);

const transformTableKeyToReadable = (key: TransactionPlanTableKey) => {
    if (key === 'contact_name') {
        return 'Contact';
    }

    return transactionPlanKeyToReadable(key);
};

const transactionPlanKeyToReadable = (key: keyof TransactionPlan) => {
    switch (key) {
        case 'next_bill_date':
            return 'Next bill date';
        case 'canceled_at':
            return 'Date cancelled';
        case 'cancel_reason':
            return 'Cancellation reason';
        case 'start_at':
            return 'Start date';
        case 'first_name':
        case 'last_name':
        case 'total_contributions':
        case 'payment_method':
            return capitalize(key.split('_').join(' '));
        case 'campaign':
        case 'phone':
        case 'frequency':
        case 'email':
        case 'amount':
        case 'contact':
        case 'method':
        case 'status':
        case 'fund':
            return capitalize(key);
        case 'id':
        case 'primary_email':
        case 'can_cancel':
        case 'canceled_by':
        default:
            return key;
    }
};

export {
    curriedTransformTableKeyToReadable,
    transformTableKeyToReadable,
    transactionPlanKeyToReadable,
};
export type { TransactionPlanTableKey };
